import React from 'react';
import {Route} from 'react-router';
import {Trans} from 'react-i18next';
import {Link} from 'react-router-dom';

export default function SignInLayout({component: Component, ...rest}) {
  return (
    <Route
      {...rest}
      render={matchProps => (
        <>
          <style>{'body { background-color: #fff; }'}</style>
          <div className="kt-grid kt-grid--ver kt-grid--root">
            <div className="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v3 kt-login--signin">
              <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor bg-white">
                <div className="kt-grid__item kt-grid__item--fluid kt-login__wrapper">
                  <div className="kt-login__container">
                    <div className="kt-login__logo">
                      <div
                        style={{
                          backgroundColor: '#1F1E2E',
                          paddingTop: '20px',
                          paddingBottom: '20px',
                        }}
                      >
                        <img
                          alt="logo"
                          src={require('../../../assets/images/layout/logo.jpg')}
                          width="50%"
                        />
                      </div>
                    </div>
                    <div className="kt-login__signin">
                      <div className="kt-login__head">
                        <h3 className="kt-login__title">
                          <Trans i18nKey="c.l.signin.login.your.account">
                            Login to your account
                          </Trans>
                        </h3>
                      </div>
                      <Component {...matchProps} />
                    </div>
                    <div className="kt-login__account">
                      <span className="kt-login__account-msg">
                        <Trans i18nKey="c.l.signin.not.have.account">
                          Don't have an account ?
                        </Trans>
                      </span>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <Link to="/sign-up" className="kt-login__account-link">
                        <Trans i18nKey="c.l.signin.button.sign.up">
                          Sign Up!
                        </Trans>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    />
  );
}
